const parseJSONSGracefully = (toParse = null, defaultValue = null) => {
    let parsedObject = null;
    try {
        parsedObject = JSON.parse(toParse);
    } catch (e) {
        return defaultValue;
    }

    return parsedObject;
};

export default parseJSONSGracefully;
